module.exports = __webpack_public_path__ + "static/media/bars.fec857d7.svg";